<template>
  <div class="my-warning">
    <span class="title">账号管理</span>
    <div class="my-warning-body">
      <div class="search-content">
        <div class="select-searchmain1">
          <div class="earch-input">
            <div class="input-li2">
              <el-input
                size="small"
                placeholder="请输入账号名称"
                prefix-icon="el-icon-search"
                v-model="searchParams.name"
              >
              </el-input>
            </div>
            <div class="input-li2">
              <span>使用端口：</span>
              <el-select
                size="small"
                filterable
                clearable
                v-model="searchParams.role"
                placeholder="请选择使用端口"
              >
                <el-option
                  v-for="item in userRoles"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="search-action">
            <el-button
              icon="el-icon-upload"
              size="small"
              @click="$refs.uploadFile.visible = true"
              >批量注册
            </el-button>
            <el-button
              size="small"
              icon="el-icon-refresh"
              plain
              @click="onReset()"
              >重置</el-button
            >
            <el-button
              size="small"
              icon="el-icon-search"
              type="primary"
              @click="getList()"
              >查询</el-button
            >
          </div>
        </div>
      </div>

      <el-table
        size="small"
        height="calc(100% - 180px)"
        :header-cell-style="{
          background: '#f5f5f5',
        }"
        :data="dataSource"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        border
      >
        <el-table-column align="center" prop="role" label="使用端口">
        </el-table-column>
        <el-table-column align="center" prop="name" label="账号名称">
        </el-table-column>
        <el-table-column align="center" prop="mobile" label="注册电话">
        </el-table-column>
        <el-table-column align="center" label="操作" fixed="right" width="220">
          <template slot-scope="{ row }">
            <el-button size="mini" type="text" @click="resetpassword(row)"
              >重置密码</el-button
            >
            <el-button size="mini" type="text" @click="changeMobile(row)"
              >修改手机号</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="paaination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="pagination.pageSizeOptions"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <uploadFile
      :url="$api.appUsers.batchRegister"
      @getData="getList()"
      ref="uploadFile"
    ></uploadFile>
    <el-dialog title="修改手机号" :visible.sync="editTelVisible" width="550px">
      <el-form
        :rules="editTelRules"
        ref="editTelForm"
        :model="editTelForm"
        size="small"
        label-width="150px"
      >
        <el-form-item label="手机号" prop="mobile">
          <el-input
            style="width: 200px"
            type="text"
            v-model="editTelForm.mobile"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editTelVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="saveMobile()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import editService from './components/editService'
import { paginations } from "@/../utils/public";

import uploadFile from "@/components/uploadFile";
export default {
  components: { uploadFile },
  data() {
    return {
      dataSource: [],
      searchParams: {
        name: "",
        role: "",
      },
      editTelForm: {
        id: 0,
        mobile: "",
      },
      editTelVisible: false,
      editTelRules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式有误",
            trigger: "blur",
          },
        ],
      },
      userRoles: [],
      pagination: {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      },
    };
  },
  computed: {},
  methods: {
    resetpassword(row) {
      this.$confirm("确认是否重置密码？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const url =
          this.$api.appUsers.resetpassword + "?loginId=" + row.loginId;

        this.$axios
          .post(url, null, true)
          .then((res) => {
            if (res.data.code === 0) {
              this.$message({
                type: "success",
                message: "重置成功!",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },

    batchRegister() {},
    changeMobile(row) {
      this.editTelVisible = true;
      this.editTelForm.id = row.appUserId;
    },
    saveMobile() {
      this.$refs.editTelForm.validate((valid) => {
        if (valid) {
          let url = this.$api.appUsers.modifyMobile;

          this.registerForm;
          this.$axios
            .post(url, this.$qs.stringify(this.editTelForm), false)
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.editTelForm = {
                  id: 0,
                  mobile: "",
                };
                this.editTelVisible = false;
                this.getList();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getParams() {
      const url = this.$api.appUsers.params;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          let { userRoles } = res.data.data;
          this.userRoles = userRoles;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    getList() {
      const parames = {
        ...this.searchParams,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        getTotal: true,
      };
      const url = this.$api.appUsers.getAppUsers;
      this.$axios.get(url, parames, false).then((res) => {
        if (res.data.code == 0) {
          let { data, total } = res.data;

          this.pagination.total = total;
          this.dataSource = data;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    // 分页切换方法
    onPage(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getList();
    },

    onReset() {
      this.pagination = {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      };
      // 重置时清空搜索数据
      this.searchParams = {
        name: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
  },

  mounted() {
    this.getParams();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.my-warning {
  height: 100%;

  .title {
    font-size: 18px;
    font-weight: bold;
    border-left: 8px solid #1890ff;
    padding-left: 12px;
  }

  .date-select {
    padding-bottom: 5px;
  }

  .my-warning-body {
    height: calc(100% - 21px);
    padding-top: 5px;
    padding: 5px 15px;

    .paaination {
      float: right;
    }
  }

  .tool {
    margin-bottom: 5px;
  }

  .tip {
    color: #000;
    font-weight: bolder;
    margin-left: 14px;
  }

  .select-searchmain1 {
    width: 100%;
    // height: 70px;
    display: flex;
    padding: 5px 0px;
    box-sizing: content-box;

    .search-action {
      display: inline-block;
      // width: 230px;
      text-align: center;
      height: 100%;
      // line-height: 70px;
    }

    .earch-input {
      flex-grow: 1;
      // padding-left: 20px;

      p {
        width: 100%;
        height: 30px;
        line-height: 30px;
      }

      .input-li2 {
        margin-right: 20px;
        width: 350px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }

      .input-li {
        margin-right: 20px;
        width: 200px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }
    }
  }
}
</style> 